let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("OcLvn")).then(() => parcelRequire('ej5Oo'));